<template>
  <div class="list">
    <el-table
      :data="data"
      border
      highlight-current-row
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      ref="table"
      @selection-change="$emit('selection-change', $event)"
      @row-click="onDetail"
    >
      <el-table-column
        v-for="(item, index) in props"
        :key="index"
        v-bind="item"
      />
    </el-table>
    <el-pagination
      background
      :page-size.sync="paging.pageSize"
      :total="paging.total"
      :page-count="paging.pageCount"
      :layout="layout"
      @size-change="onSizeChange"
      @current-change="onPageChange"
    />
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    props: {
      type: Array
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      paging: {
        currentPage: 1,
        pageCount: 1,
        pageSize: 10,
        total: 1
      },
      data: [],
      layout: 'sizes, prev, pager, next, jumper, ->, total, slot',
      loading: null
    };
  },
  async created() {
    await this.getItems();
  },
  methods: {
    async getItems() {
      try {
        this.loading = this.$loading({ target: '.app-main' });
        const { paging, value } = this;
        const params = Object.assign(paging, value);
        const { data } = await api.business.list(params);
        const { currentPage, pageCount, pageSize, total } = data;
        this.paging = {
          currentPage,
          pageCount,
          pageSize,
          total
        };
        this.data = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading.close();
      }
    },
    async onSizeChange(e) {
      this.paging.pageSize = e;
      this.getItems();
    },
    async onPageChange(e) {
      this.paging.currentPage = e;
      this.getItems();
    },
    async onDetail(row) {
      const { $router } = this;
      await $router.push({
        path: 'business/detail',
        query: { id: row.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px - 96px);
  cursor: pointer;

  /deep/ .el-table {
    overflow: auto;
  }

  /deep/ .el-pagination {
    padding: 0;
    padding-top: 24px;
  }
}
</style>
